import { render, staticRenderFns } from "./select-user.vue?vue&type=template&id=4849e530&scoped=true&"
import script from "./select-user.vue?vue&type=script&lang=ts&"
export * from "./select-user.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4849e530",
  null
  
)

export default component.exports